export default class PolyLine extends PIXI.SimpleRope {
  constructor(data) {
    super(data.texture, data.points)
    this._data = data
  }
}
